import React from 'react';
import { AuthDispatchContext } from '../context/auth-context';

export const useLogout = () => {
  const { asyncActions } = React.useContext(AuthDispatchContext);

  return (asyncActions?.logout || (async () => { return; }));
}